export class FavoriteExamPrescription {
    public idFavoriteExamPrescription: number;
    public idDoctorFavoriteGroupExamPrescription: number;
    public idPlace: number;
    public idExamType: number;
    public description: string;
    public datetimeInclusion: Date;
    public idSadtSchedule: number;
    public observationMedic: string;
}